export default "__VITE_ASSET__BvZVfQei__"